import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'

import { renderImportOptionsMenu } from './SubImportMenuItem'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import MultipleSelect from '../MultiSelect'
import EditableSelect from '../EditableSelect'
import MultipleTextInput from '../MultiValueTextInput'
import TextField from '@mui/material/TextField'

import { useZustand } from '../../hooks/useZustand'
import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import usePageInfo from '../../hooks/usePageInfo'

import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportContext } from './SubImportContext'
import { DialogsContext } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import InputLabel from '@mui/material/InputLabel'

import { format } from 'date-fns'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MobileDateTimePicker } from '@mui/x-date-pickers'

import axios from 'axios'
import qs from 'qs'

import { slugifyString, splitUrlsIntoArray } from '../../utils/index'

import { generateTextImportItems } from './TextImportItems'
import ImportingNotice from './ImportingNotice'
import { importErrorMessage } from './importError'

const addPrivateStatementsSelector = state => state.addPrivateStatementsToStore

const steps = ['Start', 'Sources', 'Settings', 'Results']

export default function RssImportDialog({
    presetContext = '',
    presetSearchString = '',
    open,
    onClose,
}) {
    const theme = useTheme() // hook to get the current theme

    const { label, location } = usePageInfo()

    const formatDate = date => {
        return format(date, 'yyyy-MM-dd HH:mm')
    }

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const {
        activeImportDialog,
        setActiveImportDialog,
        backLinkDialog,
        openImportDialog,
        closeImportDialog,
    } = React.useContext(DialogsContext)

    const [selectedContext, setSelectedContext] = React.useState(presetContext)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [presetFeeds, setPresetFeeds] = React.useState([])

    const [selectedFeeds, setSelectedFeeds] = React.useState([])

    React.useEffect(() => {
        setPresetFeeds(
            presetSearchString ? splitUrlsIntoArray(presetSearchString) : []
        )
    }, [presetSearchString])

    React.useEffect(() => {
        setSelectedFeeds(presetFeeds)
    }, [presetFeeds])

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [visitedFeeds, setVisitedFeeds] = React.useState(false)

    const [includeTeasers, setIncludeTeasers] = React.useState(false)

    const [numberOfItems, setNumberOfItems] = React.useState('25')

    const [searchString, setSearchString] = React.useState('')

    const [selectedDate, setSelectedDate] = React.useState(null)

    const [doNotSaveGraph, setDoNotSaveGraph] = React.useState(false)

    const [modifyAnalyzedText, setModifyAnalyzedText] = React.useState('none')

    const [replaceEntities, setReplaceEntities] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const menuItems = generateTextImportItems()

    const filteredMenuItems = menuItems.filter(
        ({ textInput }) =>
            textInput.includes('rss') || textInput.includes(backLinkDialog)
    )

    const { username } = React.useContext(UserContext)
    const addPrivateStatementsToStore = useZustand(addPrivateStatementsSelector)

    React.useEffect(() => {
        if (location == 'context' && label) {
            setFromInsideContext(true)
        }
    }, [label])

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const [activeStep, setActiveStep] = React.useState(2)
    const [skipped, setSkipped] = React.useState(new Set())

    const handleNext = () => {
        let newSkipped = skipped

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleStep = step => {
        setActiveStep(step)
    }

    const handleTeasersChange = () => {
        if (includeTeasers) {
            setIncludeTeasers(false)
            return 'false'
        } else {
            setIncludeTeasers(true)
            return 'true'
        }
    }

    const handleNumberOfItemsChange = event => {
        setNumberOfItems(event.target.value)
    }

    const handleSearchStringChange = event => {
        setSearchString(event.target.value)
    }

    const handleDateChange = newValue => {
        setSelectedDate(newValue) // Update the state with the new date and time
    }

    React.useEffect(() => {
        if (activeSubImportDialog.type) {
            setActiveStep(2)
            setActiveImportDialog(activeSubImportDialog.type)
        }
    }, [activeSubImportDialog])

    React.useEffect(() => {
        setImportError(null)
    }, [selectedFeeds])

    React.useEffect(() => {
        switch (activeStep) {
            case 0: // Start
                setActiveSubImportDialog(false)
                setActiveImportDialog('import')
                break
            case 1: // Sources
                setActiveSubImportDialog(false)
                setActiveImportDialog('linkImport')
                break
            case 2: // Settings
                if (!presetContext && !selectedContext) {
                    setSelectedContext(generatePresetContext())
                }
                break
            case 3: // Analysis
                if (!selectedFeeds || selectedFeeds.length == 0) {
                    setErrorMessage(`Please, add at least one RSS feed link.`)
                    setActiveStep(2)
                    break
                }
                if (!selectedContext) {
                    setErrorMessage(
                        'Please, select the graph to import your data to.'
                    )
                    setActiveStep(2)
                    break
                }
                if (selectedContext) {
                    setCompletedSteps([...completedSteps, 3])
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
        }
    }, [activeStep])

    const submitDataForm = () => {
        const rssInputString = selectedFeeds.join('\r\n')

        const dataToSend = {
            source: 'rss',
            rssinput: rssInputString,
            urlselect: 'news',
            rsssince: selectedDate ? selectedDate : '',
            rssitems: numberOfItems,
            includeteasers: includeTeasers.toString(),
            search: searchString,
            context: selectedContext,
            selectedContexts: '',
            statementid: '',
            removetags: '',
            doNotSaveGraph: doNotSaveGraph,
            modifyAnalyzedText: modifyAnalyzedText,
            replaceEntities: replaceEntities,
        }

        const dataAsForm = qs.stringify(dataToSend)

        axios
            .post('/import/rss', dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl
                } else {
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(2)
                    }
                    if (response.data.entryuid) {
                        const postedby = username
                        const res = response.data

                        // Handle private mode statements
                        if (doNotSaveGraph && res.statements) {
                            // Private mode: add statements to Zustand store without saving to DB
                            const entryuids = JSON.parse(res.entryuid)
                            const statementHashtags =
                                res.statementHashtags || {}
                            addPrivateStatementsToStore(
                                res.statements,
                                selectedContext,
                                entryuids,
                                statementHashtags
                            )
                        }

                        if (
                            window.myEventEmitter &&
                            myEventEmitter._events['chatMessage']
                        ) {
                            myEventEmitter.emit('chatMessage', {
                                source: null,
                                postedby: postedby,
                                entryuid: JSON.parse(res.entryuid),
                                entrytext: JSON.parse(res.entrytext),
                                entryname: JSON.parse(res.entryname),
                                tags: JSON.parse(res.tags),
                                timestamp: JSON.parse(res.timestamp),
                                graph: res.graph,
                                stimulateVariability: false,
                                message: res.message,
                                statementHashtags: res.statementHashtags || {},
                                doNotSaveGraph: doNotSaveGraph,
                            })
                            closeImportDialog()
                        }
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Analyze the Content of RSS Feeds:'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}

                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 2 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={7}>
                                    <DialogContentText>
                                        Please, specify the RSS feeds you want
                                        to import:
                                    </DialogContentText>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4 }}
                                    >
                                        <MultipleTextInput
                                            label={'RSS Feeds'}
                                            initialValues={presetFeeds}
                                            setSelectedValues={setSelectedFeeds}
                                            placeholder={
                                                'add an RSS feed and press enter...'
                                            }
                                            suggestions={[
                                                'http://rss.nytimes.com/services/xml/rss/nyt/World.xml',
                                                'https://news.ycombinator.com/rss',
                                                'https://techcrunch.com/feed/',
                                            ]}
                                        />
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 6 }}
                                    >
                                        <DialogContentText>
                                            Using the import app:
                                        </DialogContentText>
                                        <DialogContent
                                            sx={{
                                                pl: 0,
                                                ml: 0,
                                                marginTop: -2,
                                            }}
                                        >
                                            {renderImportOptionsMenu(
                                                filteredMenuItems,
                                                'rss'
                                            )}
                                        </DialogContent>
                                    </FormControl>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    sx={{
                                        marginTop: 3,
                                        marginBottom: 2,
                                    }}
                                >
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4, marginBottom: 4 }}
                                    >
                                        <EditableSelect
                                            selectItems={contextNames}
                                            label={'Graph Name'}
                                            initialValue={selectedContext}
                                            onChange={name =>
                                                setSelectedContext(name)
                                            }
                                        />
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4, marginBottom: 2 }}
                                    >
                                        <InputLabel id="includeteasers-label">
                                            Content to Analyze
                                        </InputLabel>
                                        <Select
                                            labelId="includeteasers-label"
                                            id="includeteasers"
                                            value={includeTeasers.toString()}
                                            onChange={handleTeasersChange} // <-- handle changes here
                                            label="Content to Analyze"
                                        >
                                            <MenuItem value={'false'}>
                                                News Headlines Only
                                            </MenuItem>
                                            <MenuItem value={'true'}>
                                                Headlines and Article Teasers
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4, marginBottom: 2 }}
                                    >
                                        <InputLabel id="includeteasers-label">
                                            Number of Items in Each Feed
                                        </InputLabel>
                                        <Select
                                            labelId="numberOfItems-label"
                                            id="numberOfItems"
                                            value={numberOfItems.toString()}
                                            onChange={handleNumberOfItemsChange} // <-- handle changes here
                                            label="Content to Analyze"
                                        >
                                            <MenuItem value={'10'}>10</MenuItem>
                                            <MenuItem value={'25'}>25</MenuItem>
                                            <MenuItem value={'50'}>50</MenuItem>
                                            <MenuItem value={'75'}>75</MenuItem>
                                            <MenuItem value={'100'}>
                                                100
                                            </MenuItem>
                                            <MenuItem value={'150'}>
                                                150
                                            </MenuItem>
                                            <MenuItem value={'200'}>
                                                200
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4, marginBottom: 2 }}
                                    >
                                        <TextField
                                            id="searchString"
                                            label="Extract the Content Containing"
                                            variant="outlined"
                                            value={searchString}
                                            onChange={handleSearchStringChange}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.main',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.dark',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderWidth: 2,
                                                    },
                                                },
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4, marginBottom: 2 }}
                                    >
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}
                                        >
                                            <MobileDateTimePicker
                                                slots={{
                                                    textField: textFieldProps => (
                                                        <TextField
                                                            {...textFieldProps}
                                                        />
                                                    ),
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: false,
                                                    },
                                                }}
                                                label="Extract Items Published Since"
                                                value={selectedDate}
                                                onChange={handleDateChange}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{
                                            marginTop: 4,
                                            marginBottom: 2,
                                        }}
                                    >
                                        <InputLabel id="modifyAnalyzedText-label">
                                            Build a knowledge graph from
                                        </InputLabel>
                                        <Select
                                            labelId="modifyAnalyzedText-label"
                                            id="modifyAnalyzedText"
                                            value={modifyAnalyzedText}
                                            onChange={event =>
                                                setModifyAnalyzedText(
                                                    event.target.value
                                                )
                                            }
                                            label="Build a knowledge graph from"
                                        >
                                            <MenuItem value={'none'} key="1">
                                                the words used in text
                                            </MenuItem>
                                            <MenuItem
                                                value={'detectEntities'}
                                                key="2"
                                            >
                                                the words and detected entities
                                            </MenuItem>
                                            <MenuItem
                                                value={'extractEntitiesOnly'}
                                                key="3"
                                            >
                                                only the detected entities
                                            </MenuItem>
                                        </Select>
                                        {modifyAnalyzedText != 'none' && (
                                            <FormHelperText
                                                sx={{ marginTop: 1 }}
                                            >
                                                By default, we extract the words
                                                used in your text. You can also
                                                choose to detect and tag
                                                entities in your text and build
                                                a graph from them.
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                    {modifyAnalyzedText != 'none' && (
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 2,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        id="replaceEntities"
                                                        checked={
                                                            replaceEntities
                                                        }
                                                        onChange={event =>
                                                            setReplaceEntities(
                                                                event.target
                                                                    .checked
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Replace entities with root concepts"
                                            />
                                            {replaceEntities && (
                                                <FormHelperText
                                                    id="replaceEntities-helperText"
                                                    sx={{ marginTop: 1 }}
                                                >
                                                    When turned on, we will not
                                                    only detect the entities,
                                                    but also replace them with
                                                    their ontological root
                                                    concepts throughout your
                                                    text.
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}

                {activeStep === 3 && (
                    <ImportingNotice
                        linkHref={`/${username}/${selectedContext}/rss`}
                    />
                )}
                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>

                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!selectedFeeds.length > 0 || activeStep == 3}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === 2 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function generatePresetContext(type) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    if (!type) return `rss-${dateAndTime}`

    return `${type}-${dateAndTime}`
}
